import { render, staticRenderFns } from "./ConfigPanelSection.vue?vue&type=template&id=2ad81463&scoped=true&"
import script from "./ConfigPanelSection.vue?vue&type=script&lang=js&"
export * from "./ConfigPanelSection.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPanelSection.vue?vue&type=style&index=0&id=2ad81463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad81463",
  null
  
)

export default component.exports